import { buildBinderListings } from '@monofe/di';
import authBinder from '../impl/auth.bind';
import mediaBinder from '../impl/media.bind';
import userStateBinder from '../impl/userState.bind';

export default buildBinderListings([authBinder, mediaBinder, userStateBinder]);
